<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
        </li>
      </ul>
    </ul>
    <div class="title-row-flex-both-end">
      <h1 class="main-title">{{langObj ? langObj?.liveDashboard : ('liveDashboard' | translate)}}</h1>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  <form [formGroup]="LiveDashboardForm">
    <div class="content-top-row content-top-row-order-processing">
      <!-- GROUP -->
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <!-- <mat-label>Status</mat-label> -->
        <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)"
          placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
            (filteredReturn)="filteredGroups = $event"></mat-select-filter>
          <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
            {{group.EG_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)"
          placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
            (filteredReturn)="filteredPlants = $event"></mat-select-filter>
          <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
            {{plant.PT_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="line" (selectionChange)="onChangeLine($event)"
          placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
            (filteredReturn)="filteredLines = $event"></mat-select-filter>
          <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
            {{line.PL_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="unit" placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}"
          panelClass="testClass" name="unit" (selectionChange)="onSubmit()">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
            (filteredReturn)="filteredUnits = $event"></mat-select-filter>
          <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
            {{unit.PU_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
  <div class="card-wrapper-list production-db">
    <div class="card-item card-item-five">
      <div class="card">
        <o3-percentage-graph [barProperties]="capacityUtilizationAnalysis"></o3-percentage-graph>
        <p class="graph-title">{{langObj ? langObj?.CapacityUtilization : ('CapacityUtilization' | translate)}}</p>
      </div>
    </div>
    <div class="card-item card-item-five">
      <div class="card">
        <o3-percentage-graph [barProperties]="oeeAnalysis"></o3-percentage-graph>
        <p class="graph-title">{{langObj ? langObj?.OEE : ('OEE' | translate)}}</p>
      </div>
    </div>

    <div class="card-item card-item-five-group">
      <div class="card">

        <o3-percentage-graph [barProperties]="availabilityAnalysis"></o3-percentage-graph>
        <p class="graph-title filter-btn" matTooltip="Pareto Dashboard">
          {{langObj ? langObj?.Availability :
          ('Availability' |
          translate)}}</p>
      </div>
    </div>
    <div class="card-item card-item-five-group">
      <div class="card">

        <o3-percentage-graph [barProperties]="performanceAnalysis"></o3-percentage-graph>
        <p class="graph-title">{{langObj ? langObj?.Performance : ('Performance' | translate)}}</p>
      </div>
    </div>
    <div class="card-item card-item-five-group">
      <div class="card">

        <o3-percentage-graph [barProperties]="qualityAnalysis"></o3-percentage-graph>
        <p class="graph-title filter-btn" matTooltip="Quality Grade Analysis"
          >{{langObj ? langObj?.Quality : ('Quality'
          |
          translate)}}</p>
      </div>
    </div>
  </div>
  <div class="menu-card-group" style="align-items: center">
    <div class="menu-card-item mat-card-height overview-cart"
      style="background-color: #0f0fd1;border: white ;height: 90px">
      <p class="title-text">{{langObj ? langObj?.Count : ('Count' | translate)}}</p>
      <p><span class="data-text">{{Count}}</span><span style="color: white; font-weight: bold;"> </span></p>
    </div>

    <div class="menu-card-item mat-card-height overview-cart"
      [ngStyle]="{'background-color':Status === 'Running' || Status === 'Running / Idle' ? '#09bc80' : 'red' }">
      <p class="title-text">{{langObj ? langObj?.Status : ('Status' | translate)}}</p>
      <p><span class="data-text"> {{Status}}</span><span style="color: white; font-weight: bold;"> </span></p>
    </div>

    <div class="menu-card-item mat-card-height overview-cart"
    style="background-color: #0f0fd1;border: white ;height: 90px">
    <p class="title-text">{{langObj ? langObj?.Alarm : ('Alarm' | translate)}}</p>
    <p><span class="data-text">{{Alarm}}</span><span style="color: white; font-weight: bold;"> </span></p>
  </div>
  </div>
  
  <div class="chart-group">
    <div class="chart-items">
      <div class="chart-title">{{langObj ? langObj?.LiverandomdataProductionCount : ('LiverandomdataProductionCount' |
        translate)}}</div>
      <div id="chartProductionCount"></div>
    </div>
    <div class="chart-items">
      <div class="chart-title">{{langObj ? langObj?.machineStatus : ('machineStatus' | translate)}}</div>
      <div id="chartMachineStatus"></div>
    </div>
  </div>
</div>